import { useMemo } from 'react';
import { movies } from '@/mocks/movies';

export default function DoubanTopList() {
  const top10 = useMemo(() => [...movies].sort((a, b) => b.douban - a.douban).slice(0, 10), []);

  return (
    <section id="douban" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="w-full max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div className="max-w-2xl">
              <span className="text-xs md:text-sm font-medium text-accent-600 tracking-widest">TOP RATED</span>
              <h2 className="mt-2 font-heading font-bold text-2xl md:text-4xl text-foreground-950">
                豆瓣高分整理：9 分以上的口碑前十
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-600 leading-relaxed">
                依据公开口碑整理的参考评分，从高到低排列。它们大多经受住了时间考验，是「不知道看什么」时最稳妥的选择。
              </p>
            </div>
            <p className="text-xs text-foreground-400 md:text-right shrink-0 max-w-xs">
              说明：评分为公开口碑整理，可能与平台实时分数存在出入，仅供参考。
            </p>
          </div>

          <ol className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
            {top10.map((m, idx) => {
              const rank = idx + 1;
              const isTop3 = rank <= 3;
              return (
                <li
                  key={m.id}
                  className="flex items-center gap-4 rounded-lg border border-background-200/80 bg-background-50 px-4 py-4 md:px-5 hover:border-accent-300 transition-colors"
                >
                  <span
                    className={`shrink-0 w-10 text-center font-heading font-black text-2xl md:text-3xl ${
                      isTop3 ? 'text-accent-500' : 'text-foreground-300'
                    }`}
                  >
                    {String(rank).padStart(2, '0')}
                  </span>

                  <div className="min-w-0 flex-1">
                    <div className="flex items-center gap-2">
                      <h3 className="font-heading font-bold text-base md:text-lg text-foreground-950 truncate">
                        {m.title}
                      </h3>
                      <span className="shrink-0 text-xs text-foreground-500">{m.year}</span>
                    </div>
                    <p className="mt-1 text-xs md:text-sm text-foreground-600 truncate">
                      {m.region} · {m.genres.join(' / ')}
                    </p>
                  </div>

                  <div className="shrink-0 text-right">
                    <span
                      className={`font-heading font-bold text-xl md:text-2xl ${
                        isTop3 ? 'text-accent-600' : 'text-foreground-800'
                      }`}
                    >
                      {m.douban.toFixed(1)}
                    </span>
                    <p className="text-[11px] text-foreground-400">整理评分</p>
                  </div>
                </li>
              );
            })}
          </ol>
        </div>
      </div>
    </section>
  );
}